export function formatarGenero(text: unknown): string {
  if (!text) return '';

  const value = String(text);

  switch (value.toUpperCase()) {
    case 'MASCULINA':
      return 'MASCULINO';

    case 'FEMININA':
      return 'FEMININO';

    case 'MISTA':
      return 'MISTO';

    default:
      return value;
  }
}
